<template>
  <div class="crop-selector">
    <!-- <p>{{$ml.get('crop')}}: {{$store.getters['satellite/crop']}}</p> -->
    <app-sel
      v-model="crop"
      @input="selectCrop"
      :items="crops"
      key-name="key"
      label-name="name"
      :label="$ml.get('Select crop')"
    >
      <template v-slot="{ items }">
        <app-sel-opt
          v-for="item in items"
          :value="item"
          :key="item.key"
        >
          {{ $ml.get(item.name) }}
        </app-sel-opt>
      </template>
    </app-sel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      crop: null,
      crops: [
        {
          key: 'general',
          name: this.$ml.get('General')
        },
        {
          key: 'corn',
          name: this.$ml.get('Corn'),
        },
        {
          key: 'potato',
          name: this.$ml.get('Potato')
        },
        {
          key: 'sugarcane',
          name: this.$ml.get('Sugarcane'),
        },
        {
          key: 'soybeans',
          name: this.$ml.get('Soybeans')
        },
        {
          key: 'rapeseed',
          name: this.$ml.get('Rapeseed'),
        },
        {
          key: 'cotton',
          name: this.$ml.get('Cotton')
        },
        {
          key: 'wheat',
          name: this.$ml.get('Wheat'),
        },
        {
          key: 'barley',
          name: this.$ml.get('Barley'),
        },
      ],
    }
  },
  methods: {
    selectCrop() {
      this.$store.dispatch('satellite/setCrop', this.crop);
    }
  }
}
</script>

<style lang="scss" scoped>
.crop-selector {
  margin-bottom: 16px;
  padding-top: 16px;
}
</style>
